import React from 'react';
import { Formik, Form } from 'formik';
import { Grid, TextField, Button } from 'ui-toolkit';
import { editEmployerNameSchema } from '../../../validation/clientPortal/editEmployerName';

interface IEditEmployerNameProps {
  initialValue?: string;
  onSubmit: (value?: string) => void;
  onReset: () => void;
}

export const EditEmployerNameForm: React.FC<IEditEmployerNameProps> = ({ initialValue, onSubmit, onReset }) => {
  return (
    <Formik
      initialValues={{ relocationEmployerName: initialValue }}
      validationSchema={editEmployerNameSchema}
      onSubmit={(value) => {
        onSubmit(value.relocationEmployerName);
      }}
      onReset={() => onReset()}
    >
      <Form>
        <Grid templateColumns={'1fr min-content'}>
          <Grid templateColumns={'1fr min-content'}>
            <TextField name={'relocationEmployerName'} placeholder={'Employer Name'} />
            <Button intent={'primary'} type={'submit'}>
              Submit
            </Button>
          </Grid>
          <Button intent={'ghost'} type={'reset'}>
            Cancel
          </Button>
        </Grid>
      </Form>
    </Formik>
  );
};
